// src/support/supportConfig.js
// Central configuration for the optional support module.
// Toggle the module on/off via env var or override at runtime.

const defaults = {
  /** Master switch — set REACT_APP_SUPPORT_ENABLED=false to disable */
  enabled: (process.env.REACT_APP_SUPPORT_ENABLED ?? 'true') !== 'false',

  /** Skip license check (dev / free-tier) */
  bypassLicense: (process.env.REACT_APP_SUPPORT_BYPASS_LICENSE ?? 'false') === 'true',

  /** Categories available in the ticket form */
  categories: [
    { value: 'refund', label: 'Refund' },
    { value: 'technical', label: 'Technical Issue' },
    { value: 'event_inquiry', label: 'Event Inquiry' },
    { value: 'account', label: 'Account' },
    { value: 'other', label: 'Other' },
  ],

  /** Priority levels */
  priorities: ['low', 'normal', 'high', 'urgent'],

  /** Max tickets per user (0 = unlimited) */
  maxTicketsPerUser: Number(process.env.REACT_APP_SUPPORT_MAX_TICKETS || 0),

  /** License module price in PGT */
  licensePrice: Number(process.env.REACT_APP_SUPPORT_LICENSE_PRICE || 150),
};

let _config = { ...defaults };

/**
 * Get current support config (read-only copy).
 */
export function getSupportConfig() {
  return { ..._config };
}

/**
 * Override config at runtime (e.g. from admin panel or server response).
 * Only merges provided keys.
 */
export function configureSupportModule(overrides = {}) {
  _config = { ..._config, ...overrides };
}

/**
 * Check whether the support module is enabled.
 */
export function isSupportEnabled() {
  return _config.enabled;
}

export default _config;
